module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "Home - Scholarship.89ef70e3.jpg" + "?" + Date.now();